module.exports = __webpack_public_path__ + "img/heart.4d15da80.png";